import React from 'react'
import styles from './ToggleButton.module.scss'

import PropTypes from 'prop-types'


export default function ToggleButton(props) {
    const {variant, size, onToggle, status} = props
    const SIZE = {
        'xsmall': styles.xsmall,
        'small': styles.small,
        'medium': styles.medium
    }

    return (
        <label className={styles.switch + ` ${size ? SIZE[size] : ''}`}>
            <input type="checkbox" onClick={onToggle} checked={status} readOnly={true}/>
            <span className={styles.slider + ` ${variant ? styles[variant] : ''}`}> </span>
        </label>
    )
}


ToggleButton.propTypes = {
    variant: PropTypes.oneOf(['round']),
    size: PropTypes.oneOf(['xsmall', 'small', 'medium']),
    onToggle: PropTypes.func
}
